import { render, staticRenderFns } from "./gs-business-characteristics.vue?vue&type=template&id=fc10b336"
import script from "./gs-business-characteristics.vue?vue&type=script&lang=ts"
export * from "./gs-business-characteristics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports